import { defineComponent as n, computed as o, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "830ba16c-a602-494d-a91a-64244f4208bf" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#830ba16c-a602-494d-a91a-64244f4208bf)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h167l86 41.2L345 0h167v512H345l-87.9-41.4L167 512H0z"
}, null, -1), v = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M167 0h178v512H167z"
}, null, -1), g = { fill: "none" }, x = ["r"], B = /* @__PURE__ */ n({
  __name: "pe",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (a(), i("title", k, d(e.flagName), 1)) : f("", !0),
        p,
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=pe-d0849fac.js.map
